'use client';
import { isArray, isNumber } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const getStylesString = (theme, descriptor)=>{
    const { width = 1, color, style = 'solid', reset } = descriptor || {};
    if (reset) {
        return 'none';
    }
    return [
        isNumber(width) ? `${width}px` : width,
        style,
        theme.fn.themeColor(color, theme.palette.border.element)
    ].join(' ');
};
const selectorLookup = {
    right: 'borderRight',
    left: 'borderLeft',
    top: 'borderTop',
    bottom: 'borderBottom'
};
const fallbackSelector = 'border';
const getSelectorByPos = (pos)=>pos ? selectorLookup[pos] || fallbackSelector : fallbackSelector;
const getStylesObject = (theme, descriptor)=>{
    const { pos } = descriptor, other = _object_without_properties_loose(descriptor, [
        "pos"
    ]);
    if (isArray(pos)) {
        const result = descriptor.radius ? {
            borderRadius: descriptor.radius
        } : {};
        for (const currentPosition of pos){
            result[getSelectorByPos(currentPosition)] = getStylesString(theme, other);
        }
        return result;
    }
    return _extends({}, descriptor.radius && {
        borderRadius: descriptor.radius
    }, {
        [getSelectorByPos(pos)]: getStylesString(theme, other)
    });
};
const border = (theme)=>(options)=>{
        if (!options) {
            return {
                border: getStylesString(theme)
            };
        }
        if (isArray(options)) {
            let result = {};
            for (const descriptor of options){
                result = _extends({}, result, getStylesObject(theme, descriptor));
            }
            return result;
        }
        return getStylesObject(theme, options);
    };

export { border };
//# sourceMappingURL=border.js.map
